export default "__VITE_ASSET__DO_AaQ$1__"